export default __webpack_public_path__ + "static/media/keyvis_text_mob.9cd4217f.png";